import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Button, Form, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { LOPDAOTAOTHUCHANH_API, DOITUONG_API, DOTTUYENSINH_API } from '@app/utils/apiUrl';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    messageToast, 
    objectShowNumber, 
    status200,
    trangThaiDotTuyenSinhValue,
    objectTrangThaiDotTuyenSinh,
    doiTuongValue,
    objectDoiTuong,
    loaiTuyenSinhValue,
    objectLoaiTuyenSinh,
    DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT
} from '../../../../../utils/define';
import { ConfirmModal } from '../../../../../modules/modal/ConfirmModal';
import ChiTietLopDaoTaoThucHanhModal from './ChiTietLopDaoTaoThucHanhModal';
import ThanhToanLePhiModal from '../thanhToanLePhi/ThanhToanLePhiModal';

const LopDaoTaoThucHanh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [namKhaiGiang, setNamKhaiGiang] = useState(new Date().getFullYear());

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const [openModalChiTiet, setOpenModalChiTiet] = useState(false);
    const [dataChiTiet, setDataChiTiet] = useState(null);

    const [openModalThanhToan, setOpenModalThanhToan] = useState(false);
    const [entityThanhToanId, setEntityThanhToanId] = useState('');
    const [entityThanhToanName, setEntityThanhToanName] = useState('');

    const handleOpenModalChiTiet = (item) => {
        setDataChiTiet(item);
        setOpenModalChiTiet(true);
    };

    const handleCloseModalChiTiet = () => {
        setOpenModalChiTiet(false);
        setDataChiTiet(null);
    };

    const handleOpenModalThanhToan = (id, name) => {
        setEntityThanhToanId(id);
        setEntityThanhToanName(name);
        setOpenModalThanhToan(true);
    };

    const handleCloseModalThanhToan = () => {
        setOpenModalThanhToan(false);
        setEntityThanhToanId('');
        setEntityThanhToanName('');
    };

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }
    if (paramUrl.get('nam') != null && parseInt(paramUrl.get('nam'), 10) !== namKhaiGiang) {
        setNamKhaiGiang(parseInt(paramUrl.get('nam'), 10));
    }

    const replaceHistory = (Page, Size, Search, Nam) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH, {
                page: Page,
                size: Size,
                search: Search,
                nam: Nam
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['lopDaoTaoThucHanhData', valueSearch, page, pageSize, namKhaiGiang],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                NamKhaiGiang: namKhaiGiang
            };
            replaceHistory(page, pageSize, valueSearch, namKhaiGiang);
            return Get(LOPDAOTAOTHUCHANH_API.GET_PAGING, null, model);
        },
        { keepPreviousData: true }
    );

    const { data: doiTuongData } = useQuery(
        ['doiTuongDataLopThucHanh'],
        () => Get(DOITUONG_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }),
        { keepPreviousData: true }
    );
    const listDoiTuong = doiTuongData?.data?.$values || doiTuongData?.data || [];

    const { data: listNamData } = useQuery(
        ['listNamKhaiGiangThucHanh'],
        () => Get(LOPDAOTAOTHUCHANH_API.GET_LIST_NAM_KHAI_GIANG, null, null),
        { keepPreviousData: true }
    );
    const rawListNam = (Array.isArray(listNamData) ? listNamData : listNamData?.$values) || [];
    const listNam = rawListNam.length > 0 ? Array.from(new Set(rawListNam)).sort((a, b) => a - b) : [new Date().getFullYear()];

    useEffect(() => {
        if (rawListNam.length > 0 && !rawListNam.includes(namKhaiGiang)) {
            const maxYear = Math.max(...rawListNam);
            setNamKhaiGiang(maxYear);
            replaceHistory(1, pageSize, search, maxYear);
        }
    }, [listNamData, namKhaiGiang]);

    useEffect(() => {
        refetch();
    }, [pageSize, page, namKhaiGiang]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch, namKhaiGiang);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, namKhaiGiang);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, namKhaiGiang);
    };

    const onChangeNamKhaiGiang = (e) => {
        const nam = Number(e.target.value);
        setNamKhaiGiang(nam);
        setPage(1);
        replaceHistory(1, pageSize, search, nam);
    };

    const deleteFunc = useMutation((value) => DeleteSingle(LOPDAOTAOTHUCHANH_API.DELETE_ITEM, value, null));

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const getChucDanhName = (ids) => {
        if (!ids) return '';
        const idArray = ids.split(',');
        const names = idArray.map(id => {
            const found = listDoiTuong.find(x => x.id === id || x.Id === id);
            return found ? (found.tenDoiTuong || found.TenDoiTuong) : id;
        });
        return names.join(', ');
    };

    return (
        <div className="container-fluid">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <Nav variant="pills" className="flex-row">
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.DOTTUYENSINH_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh Tiến sĩ</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.LOPDAOTAOLIENTUC_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh đào tạo liên tục</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh đào tạo thực hành</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <div className="d-flex align-items-center">
                            <span className="font-weight-bold mr-2">Năm:</span>
                            <Form.Control as="select" value={namKhaiGiang} onChange={onChangeNamKhaiGiang} style={{ width: '120px' }}>
                                {listNam.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Control>
                            <NavLink to={URI_INTERNAL.LOPDAOTAOTHUCHANH_CREATE_PATH} className="btn btn-success ml-3">
                                Thêm mới
                            </NavLink>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead className="text-nowrap">
                                <tr>
                                    <th>STT</th>
                                    <th>Tên khóa học</th>
                                    <th>Loại tuyển sinh</th>
                                    <th>Ngày khai giảng</th>
                                    <th>Đối tượng</th>
                                    <th>Chức danh</th>
                                    <th>Trạng thái</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={8}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={8}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={8}>Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>{item.tenKhoaHoc || item.TenKhoaHoc}</td>
                                            <td>{getLabelFromEnum(item.loaiTuyenSinh ?? item.LoaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue)}</td>
                                            <td>
                                                {(item.ngayKhaiGiang || item.NgayKhaiGiang) && moment(item.ngayKhaiGiang || item.NgayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT)}
                                            </td>
                                            <td>{getLabelFromEnum(item.doiTuongEnum ?? item.DoiTuongEnum, objectDoiTuong, doiTuongValue)}</td>
                                            <td>{getChucDanhName(item.chucDanhIds || item.ChucDanhIds)}</td>
                                            <td>{getLabelFromEnum(item.trangThaiDotTuyenSinh ?? item.TrangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue)}</td>
                                            <td className="text-nowrap">
                                                <Button
                                                    variant="info"
                                                    size="sm"
                                                    className="mr-2"
                                                    onClick={() => handleOpenModalChiTiet(item)}>
                                                    Xem
                                                </Button>
                                                <Button
                                                    variant="warning"
                                                    size="sm"
                                                    className="mr-2"
                                                    onClick={() => handleOpenModalThanhToan(item.id, item.tenKhoaHoc || item.TenKhoaHoc)}>
                                                    Thanh toán
                                                </Button>
                                                <NavLink
                                                    className="btn btn-primary btn-sm mr-2"
                                                    to={`${URI_INTERNAL.LOPDAOTAOTHUCHANH_EDIT_PATH}?id=${item.id}`}>
                                                    Sửa
                                                </NavLink>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => deleteAction(item.id, item.tenKhoaHoc || item.TenKhoaHoc)}>
                                                    Xóa
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        goBackAfterDelete={false}
                        handleAccept={acceptDelete}
                        handleCancel={cancelDelete}
                        content={confirmDelMessage}
                    />

                    <ChiTietLopDaoTaoThucHanhModal
                        isOpen={openModalChiTiet}
                        onClose={handleCloseModalChiTiet}
                        data={dataChiTiet}
                        getChucDanhName={getChucDanhName}
                    />

                    <ThanhToanLePhiModal
                        isOpen={openModalThanhToan}
                        onClose={handleCloseModalThanhToan}
                        entityId={entityThanhToanId}
                        entityName={entityThanhToanName}
                        entityType="LopDaoTaoThucHanh"
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default LopDaoTaoThucHanh;
